import { createReducer } from 'redux-starter-kit';

import { WorkbenchesReducerType } from './workbenches.types';
import {
  SET_WORKBENCH,
  CLEAR_WORKBENCH,
  SET_WORKBENCHES,
  CLEAR_WORKBENCHES,
} from './workbenches.actions';

const initialState: WorkbenchesReducerType = {
  list: {
    count: -1,
    next: '',
    previous: '',
    results: [],
  },
  selected: {
    id: -1,
    name: '',
    slug: '',
    icon: '',
    icon_url: '',
    active: false,
  },
};

export default createReducer(initialState, {
  [SET_WORKBENCHES]: (state, action) => {
    state.list = action.payload;
  },
  [CLEAR_WORKBENCHES]: (state) => {
    state.list = initialState.list;
  },
  [SET_WORKBENCH]: (state, action) => {
    state.selected = action.payload;
  },
  [CLEAR_WORKBENCH]: (state) => {
    state.selected = initialState.selected;
  },
});
